export default __webpack_public_path__ + "static/halftone-3@2x-6a5e49c41232b90f4bf3b099a04098de.png";